import { RecipeJsonLd } from "next-seo";
import { Video } from "next-seo/lib/types";

export const RecipeStructureData = ({
  name,
  description,
  video,
  image,
  author,
  recipeYield,
  prepTime,
  totalTime,
  category,
  keywords,
  datePublished,
  recipeIngredient,
  recipeInstructions,
  aggregateRating,
}: {
  name?: string;
  description?: string;
  video?: Video;
  image?: string[];
  author?: string;
  category?: string;
  keywords?: string;
  datePublished?: string;
  recipeYield?: string;
  prepTime?: string;
  totalTime?: string;
  recipeIngredient?: any;
  recipeInstructions?: any;
  aggregateRating?: any;
}) => {
  return (
    <RecipeJsonLd
      name={name}
      authorName={author}
      description={description}
      ingredients={recipeIngredient}
      instructions={recipeInstructions}
      images={image}
      video={
        video && {
          contentUrl: video,
          thumbnailUrls: `${image}`,
          name: `${name} video`,
          description,
          uploadDate: datePublished,
        }
      }
      yields={recipeYield}
      category={category}
      prepTime={prepTime}
      totalTime={totalTime}
      keywords={keywords}
      datePublished={datePublished}
      aggregateRating={aggregateRating}
    />
  );
};
